import { useState } from "react";
import { Button, Col } from "antd";
import FolderUploader from "modules/SubComponents/Upload/FolderUploader";
import { toastError, toastSuccess } from "helpers/toasters";
import { editIntroductionVideo } from "Network";

export default function VideoUploader({ title, videoPath }) {
  const [filePath, setFilePath] = useState(null);

  const editIntroVideo = () => {
    const data = {
      introductionVideoPath: filePath,
    };
    editIntroductionVideo(
      data,
      (success) => {
        toastSuccess(success?.data?.message || "Updated successfully.");
      },
      (error) => {
        toastError("Failed to update video.");
      }
    );
  };

  return (
    <div className="tv-photos__upload-section">
      <h3>{title}</h3>
      <Col xs={24} style={{ position: "relative" }}>
        <FolderUploader
          episodeIndex={1}
          srcVideo={filePath || videoPath}
          setFilePath={(videoPath) => setFilePath(videoPath)}
          //   ref={folderUploaderRef}
          //   observeUploading={observeUploading}
          //   getVideoDuration={(duration) =>
          //     handleGetVideoDuration(episodeIndex, duration)
          //   }
          //   episodeIndex={episodeIndex}
        />
      </Col>
      {filePath && (
        <Button
          className="primary-popup-button align-self-end"
          type="primary"
          onClick={editIntroVideo}
        >
          Save
        </Button>
      )}
    </div>
    //   </div>
    // </div>
  );
}
